export enum FetchStatus {
  FETCHING = 'FETCHING',
  FETCHING_MORE = 'FETCHING_MORE',
  REFETCHING = 'REFETCHING',
  ERROR = 'ERROR',
  FETCH_MORE_ERROR = 'FETCH_MORE_ERROR',
  FETCHED = 'FETCHED',
  UNINITIALIZED = 'UNINITIALIZED',
  NOT_FOUND = 'NOT_FOUND'
}
